var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.notKeepPath.indexOf(_vm.$route.path) ==-1 || _vm.$route.meta.keep)?_c('keep-alive',[(_vm.$route.meta.keep)?_c('router-view'):_vm._e()],1):_vm._e(),(!_vm.$route.meta.keep)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }